export default __webpack_public_path__ + "static/mp_favicon-ce35f60e15526b9d5b408e8163d5f47b.ico";